import { render, staticRenderFns } from "./PresentSticker.vue?vue&type=template&id=741230bd&scoped=true"
import script from "./PresentSticker.vue?vue&type=script&lang=js"
export * from "./PresentSticker.vue?vue&type=script&lang=js"
import style0 from "./PresentSticker.vue?vue&type=style&index=0&id=741230bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741230bd",
  null
  
)

export default component.exports